/* Consulta somente frete; nunca adiciona itens nem altera o carrinho. */
(() => {
  if (customElements.get('isafe-product-shipping')) return;
  class ProductShipping extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.root = this.closest('product-info');
      this.form = this.querySelector('form');
      this.input = this.querySelector('input');
      this.button = this.querySelector('button');
      this.status = this.querySelector('[role="status"]');
      this.results = this.querySelector('.isafe-pv9-shipping-results');
      this.variants = JSON.parse(this.querySelector('script').textContent);
      this.form.addEventListener('submit', e => { e.preventDefault(); this.quote(); });
      this.input.addEventListener('input', () => {
        const digits = this.input.value.replace(/\D/g, '').slice(0, 8);
        this.input.value = digits.replace(/^(\d{5})(\d)/, '$1-$2');
        this.input.removeAttribute('aria-invalid'); this.reset();
      });
      this.onQuantity = e => { if (e.target.matches('input[name="quantity"]')) this.reset(); };
      this.root.addEventListener('change', this.onQuantity);
      if (typeof subscribe === 'function') this.unsubscribe = subscribe('variant-change', e => {
        if (e.data.sectionId === this.root.dataset.section) this.reset();
      });
    }
    disconnectedCallback() {
      this.controller?.abort(); this.unsubscribe?.();
      this.root?.removeEventListener('change', this.onQuantity); this.initialized = false;
    }
    reset() {
      this.controller?.abort(); this.controller = null;
      this.button.disabled = false; this.button.textContent = 'Calcular';
      this.results.replaceChildren(); this.status.textContent = 'Consulte as opções para o produto e a quantidade selecionados.';
    }
    async quote() {
      this.reset();
      const cep = this.input.value.replace(/\D/g, '');
      if (!/^\d{8}$/.test(cep) || /^(\d)\1{7}$/.test(cep)) {
        this.input.setAttribute('aria-invalid', 'true');
        this.status.textContent = 'Digite um CEP válido com 8 números.'; this.input.focus(); return;
      }
      const id = this.root.querySelector('product-form input[name="id"]')?.value;
      const variant = this.variants[id];
      const quantityInput = this.root.querySelector('.isafe-pv9-quantity-row input[name="quantity"]');
      const quantity = Number(quantityInput?.value || 1);
      if (!variant?.available) { this.status.textContent = 'Esta opção está indisponível. Escolha outra para consultar a entrega.'; return; }
      if (!variant.requiresShipping) { this.status.textContent = 'Este produto não precisa de entrega física.'; return; }
      if (!Number.isInteger(quantity) || quantity < 1 || (quantityInput && !quantityInput.checkValidity())) {
        this.status.textContent = 'Escolha uma quantidade válida antes de calcular.'; return;
      }
      const controller = new AbortController(); this.controller = controller;
      const timeout = setTimeout(() => controller.abort(), 20000);
      this.button.disabled = true; this.button.textContent = 'Calculando…';
      this.status.textContent = 'Consultando as opções de entrega…';
      try {
        const response = await fetch(this.dataset.endpoint, {
          method:'POST', credentials:'omit', signal:controller.signal,
          headers:{'Content-Type':'application/json'},
          body:JSON.stringify({cep,items:[{...variant,quantity}],total:variant.price * quantity / 100})
        });
        // A rota distingue "não deu para consultar" de "não há transportadora para
        // este CEP". São respostas diferentes e o cliente merece ler a diferença:
        // dizer "tente de novo" quando não existe atendimento faz a pessoa insistir à toa.
        if (!response.ok) {
          let motivo = null;
          try { motivo = await response.json(); } catch (e) {}
          if (this.controller !== controller) return;
          this.results.replaceChildren();
          if (response.status === 429) {
            this.status.textContent = 'Muitas consultas seguidas. Aguarde alguns instantes e tente de novo.';
          } else if (motivo && motivo.semAtendimento) {
            this.status.textContent = 'Nenhuma transportadora atende este CEP com as medidas deste produto. Fale com a gente pelo WhatsApp.';
          } else if (response.status === 422) {
            this.status.textContent = 'Este produto não precisa de entrega física.';
          } else if (response.status === 400) {
            this.input.setAttribute('aria-invalid', 'true');
            this.status.textContent = 'Digite um CEP válido com 8 números.';
          } else {
            this.status.textContent = 'Não foi possível consultar o frete agora. Tente novamente ou confira as opções no checkout.';
          }
          this.button.textContent = 'Calcular';
          return;
        }
        const rates = await response.json();
        if (!Array.isArray(rates) || !rates.length) throw new Error('quote');
        if (this.controller !== controller) return;
        for (const rate of rates) {
          if (!Number.isFinite(rate.price) || rate.price < 0 || !rate.deliveryTime) throw new Error('quote');
          const row = document.createElement('div'); row.className = 'isafe-pv9-shipping-result';
          const heading = document.createElement('div');
          const service = document.createElement('strong'); service.textContent = [rate.carrier,rate.service].filter(Boolean).join(' · ');
          const price = document.createElement('strong'); price.textContent = rate.price === 0 ? 'Grátis' : rate.price.toLocaleString('pt-BR',{style:'currency',currency:'BRL'});
          const delivery = document.createElement('p'); delivery.textContent = rate.deliveryTime;
          heading.append(service,price); row.append(heading,delivery); this.results.append(row);
        }
        this.status.textContent = 'Estimativa para esta seleção. Valor e prazo confirmados no checkout.';
        this.button.textContent = 'Recalcular';
      } catch (error) {
        if (this.controller !== controller) return;
        this.results.replaceChildren();
        this.status.textContent = 'Não foi possível consultar o frete agora. Tente novamente ou confira as opções no checkout.';
      } finally {
        clearTimeout(timeout);
        if (this.controller === controller) { this.button.disabled = false; this.controller = null; if(this.button.textContent === 'Calculando…') this.button.textContent = 'Calcular'; }
      }
    }
  }
  customElements.define('isafe-product-shipping', ProductShipping);
})();
